module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./~/ace-builds/src-noconflict/mode-text.js
// module id = 7115715522949816
// module chunks = 0